import { ref, Ref } from "vue";
import { loadClient } from "@/business/files/application/loadClient";
import { loadInventory } from "@/business/files/application/loadInventory";
import { loadInvoice } from "@/business/files/application/loadInvoice";
import { loadOrder } from "@/business/files/application/loadOrder";
import { loadSample } from "@/business/files/application/loadSample";
import { loadSalesReport } from "@/business/files/application/loadSalesReport";

export function filesUse() {
    const sampleFileSelected: Ref<File | null> = ref(null);
    const inventoryFileSelected: Ref<File | null> = ref(null);
    const invoiceFileSelected: Ref<File | null> = ref(null);
    const orderFileSelected: Ref<File | null> = ref(null);
    const clientFileSelected: Ref<File | null> = ref(null);
    const reportFileSelected: Ref<File | null> = ref(null);
    const sampleFileName: Ref<string> = ref("");
    const inventoryFileName: Ref<string> = ref("");
    const invoiceFileName: Ref<string> = ref("");
    const orderFileName: Ref<string> = ref("");
    const clientFileName: Ref<string> = ref("");
    const reportFileName: Ref<string> = ref("");

    function onSampleFileSelected(event: any) {
        sampleFileSelected.value = event.target.files[0];
        sampleFileName.value = sampleFileSelected.value?.name ?? "";
    }

    function onInventoryFileSelected(event: any) {
        inventoryFileSelected.value = event.target.files[0];
        inventoryFileName.value = inventoryFileSelected.value?.name ?? "";
    }

    function onInvoiceFileSelected(event: any) {
        invoiceFileSelected.value = event.target.files[0];
        invoiceFileName.value = invoiceFileSelected.value?.name ?? "";
    }

    function onOrderFileSelected(event: any) {
        orderFileSelected.value = event.target.files[0];
        orderFileName.value = orderFileSelected.value?.name ?? "";
    }

    function onClientFileSelected(event: any) {
        clientFileSelected.value = event.target.files[0];
        clientFileName.value = clientFileSelected.value?.name ?? "";
    }

    function onReportFileSelected(event: any) {
        reportFileSelected.value = event.target.files[0];
        reportFileName.value = reportFileSelected.value?.name ?? "";
    }

    async function sampleFileOperation(file: File) {
        await loadSample.execute(file);
    }

    async function inventoryFileOperation(file: File) {
        await loadInventory.execute(file);
    }

    async function invoiceFileOperation(file: File) {
        await loadInvoice.execute(file);
    }

    async function clientFileOperation(file: File) {
        await loadClient.execute(file);
    }

    async function orderFileOperation(file: File) {
        await loadOrder.execute(file);
    }

    async function reportFileOperation(file: File) {
        await loadSalesReport.execute(file);
    }

    return {
        sampleFileSelected,
        inventoryFileSelected,
        invoiceFileSelected,
        orderFileSelected,
        clientFileSelected,
        reportFileSelected,
        sampleFileName,
        inventoryFileName,
        invoiceFileName,
        orderFileName,
        clientFileName,
        reportFileName,
        onSampleFileSelected,
        onInventoryFileSelected,
        onInvoiceFileSelected,
        onOrderFileSelected,
        onClientFileSelected,
        onReportFileSelected,
        sampleFileOperation,
        inventoryFileOperation,
        invoiceFileOperation,
        clientFileOperation,
        orderFileOperation,
        reportFileOperation,
    };
}